import styled from 'styled-components';

export const Label = styled.span<{ required?: boolean; labelWithoutAsterisk?: boolean }>`
  &::after {
    content: ${({ required, labelWithoutAsterisk }) => required && !labelWithoutAsterisk && '"*"'};
    padding-left: 5px;
  }
`;
